import { Trans, useTranslation } from 'react-i18next';
import { useActiveConversation } from '../../contexts/ActiveConversationContext';
import { useTheme } from '../../contexts/ThemeContext';
import { IS_STAGING } from '../../i18n';
import { ChatHeader } from '../layout/ChatHeader';
import { Composer } from './Composer';
import { MessageList } from './MessageList';

const GREETING_KEYS: Record<string, string> = {
  morning: 'greetingMorning',
  afternoon: 'greetingAfternoon',
  evening: 'greetingEvening',
};

export function ChatMain() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { conversationId, messages, loading, runError, runState } = useActiveConversation();

  const isFreshNew = conversationId === null && messages.length === 0 && runState === 'idle';

  return (
    <div className="chat-main">
      <ChatHeader />

      {loading ? (
        <div className="loading-screen">{t('loading')}</div>
      ) : isFreshNew ? (
        <div className="welcome-state">
          <div className="welcome-logo">
            <img src="/helloant_logo_cropped.png" alt="Hello Ant" />
          </div>
          <div className="welcome-title">{t(IS_STAGING ? 'welcomeTitleStaging' : 'welcomeTitle')}</div>
          <div className="welcome-sub">
            <Trans i18nKey="welcomeSub" components={{ strong: <strong /> }} />
          </div>
          <div className="welcome-greeting">{t(GREETING_KEYS[theme] ?? 'greetingMorning')}</div>
        </div>
      ) : (
        <MessageList />
      )}

      {runError && <div className="run-error">{runError}</div>}

      <Composer />
    </div>
  );
}
